import { useCallback, useState } from 'react';
import { SortState, UNSORTED } from 'types/sorting';
import { getNextSortState } from 'utils/sorting';

interface UseSortStateReturn {
  sortState: SortState;
  toggleSort: (columnKey: string) => void;
  setSortState: (state: SortState) => void;
  clearSort: () => void;
}

export default function useSortState(initialState: SortState = UNSORTED): UseSortStateReturn {
  const [sortState, setSortState] = useState<SortState>(initialState);

  const toggleSort = useCallback((columnKey: string) => {
    setSortState((prev) => getNextSortState(prev, columnKey));
  }, []);

  const clearSort = useCallback(() => {
    setSortState(UNSORTED);
  }, []);

  return { sortState, toggleSort, setSortState, clearSort };
}
